import { createContext } from "react";
import IBaseListingResponse from "../../../utils/api/base-listing-response";
import { DEFAULT_FUNCTION, DEFAULT_QUERY } from "../../../utils/helpers/constants";
import { IStorageUnitQuery } from "../../../models/wms/storage-unit/query";
import { IStorageUnit, IStorageUnitDetails } from "../../../models/wms/storage-unit/response";
import { ICreateStorageUnit, IUpdateStorageUnit } from "../../../models/wms/storage-unit/request";

export type StorageUnitLoading =
  | "list"
  | "details"
  | "create"
  | "update"
  | "delete";

export interface IInternalState {
  loading: StorageUnitLoading[];
  list?: IBaseListingResponse<IStorageUnit>;
  query: IStorageUnitQuery;
  details?: IStorageUnitDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: IStorageUnitDetails) => void;
    createStorageUnit: (request: ICreateStorageUnit) => void;
    updateStorageUnit: (id: number, request: IUpdateStorageUnit) => void;
    deleteStorageUnit: (id: number) => void;
    reorderStorageUnit: (id: number, pickSequence: number) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: IStorageUnitQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    createStorageUnit: DEFAULT_FUNCTION,
    updateStorageUnit: DEFAULT_FUNCTION,
    deleteStorageUnit: DEFAULT_FUNCTION,
    reorderStorageUnit: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const StorageUnitContext = createContext(externalState);
export default StorageUnitContext;
